<wiz-h-divider width="100%" height="100%" gap="0">
  <wiz-hgroup width="40%" minWidth="200px" height="100%" style="overflow-x: auto">
    <wiz-vgroup width="250px" height="100%">
      <multi-display #mdMain width="100%" height="100%" [config]="mainConfig"></multi-display>
    </wiz-vgroup>

    <wiz-vgroup width="100%" height="100%" class="section-container-parent">
      <wiz-tree class="section-container" #treeContent width="100%" height="100%" [wizDataProvider]="contentDS"
        [actionsRenderer]="contentRenderer"></wiz-tree>

      <wiz-vgroup width="100%" class="section-container">
        <filter-component #contentFilter width="100%"> </filter-component>
      </wiz-vgroup>
    </wiz-vgroup>
  </wiz-hgroup>


  <wiz-vgroup width="60%" minWidth="600px" height="100%" class="section-container-parent">

    <wiz-vgroup width="100%" class="section-container">
      <!-- ajout édition d'un inc / exc-->
      <wiz-hgroup width="100%" verticalAlign="center">
        <wiz-icon #btnCreate [wizTooltip]="'$.incexc.key.title.$'" tooltipPlacement="right" class="image-back-orange"
          (click)="newKey()">add</wiz-icon>
        <wiz-label class="titleLabel" [wizLabel]="'$.incexc.key.title.$'" [wizTextBehavior]="'truncate'"
          width="100%"></wiz-label>
      </wiz-hgroup>

      <wiz-tile-list #tileKey width="100%" height="200px" itemHeight="50" itemWidth="240"
        [wizDataProvider]="currentKeyDS" [wizItemRenderer]="currentKeyRenderer" *ngIf="hasCurrentKey"></wiz-tile-list>

      <wiz-hgroup #toggleZone padding="3px" width="100%" gap="10" [visible]="hasCurrentKey" verticalAlign="center">
        <wiz-translation-basic #trsDesc [wizTranslationMode]="'textarea'" [maxTranslation]="6"
          [wizLabel]="'$.incexc.description.$'" width="250px" height="70px"></wiz-translation-basic>
        <wiz-toggle #toggleInc [leftText]="'$.incexc.include.short.$'" [rightText]="'$.incexc.exclude.short.$'"
          width="100px" height="40px"></wiz-toggle>
        <wiz-spacer width="100%"></wiz-spacer>
        <wiz-vgroup width="200px" height="100%" verticalAlign="center">
          <wiz-button #btnSave [wizIcon]="'arrow-right'" [iconPlacement]="'right'"
            [wizLabel]="'$.common.save.modification.$'" [wizDisabled]="!maySave" (wizClick)="doSave()"></wiz-button>
          <wiz-button #btnCancel class="cancel-button" [wizIcon]="'arrow-left'"
            [wizLabel]="'$.common.cancel.modification.$'" [wizDisabled]="!hasUpdate"
            (wizClick)="doCancel()"></wiz-button>
        </wiz-vgroup>
      </wiz-hgroup>

    </wiz-vgroup>

    <wiz-vgroup width="100%" height="100%" class="section-container">
      <wiz-hgroup width="100%" gap="20" verticalAlign="center">
        <wiz-label class="smallTitleLabel" width="100%" [wizLabel]="'$.incexc.key.list.$'"></wiz-label>
        <wiz-icon [wizTooltip]="'$.common.export.$'" tooltipPlacement="left" (click)="doAct('export')"
          class="image-purple">download</wiz-icon>
        <wiz-icon [wizTooltip]="'$.common.import.$'" tooltipPlacement="left" (click)="doAct('import')"
          class="image-purple">upload</wiz-icon>
      </wiz-hgroup>
      <!-- <wiz-vgroup width="100%" height="100%" class="section-container" padding=5px> -->

      <wiz-ag-grid #mdInc width="100%" height="100%" class="ag-theme-alpine" [wizDatasource]="keyDS"
        wizRowSelection="single" [frameworkComponents]="keyGridComponents" [columnDefs]="keyGridColumns">
      </wiz-ag-grid>
      <filter-component #keyFilter> </filter-component>
    </wiz-vgroup>


  </wiz-vgroup>
</wiz-h-divider>